const MINI_APP_ENVIRONMENT = process.env.REACT_APP_MINI_APP_URL;

const constructMiniAppLink = (route, hashCode) => {
	if (!route || !hashCode)
		throw new Error('route and hash code are required for this function');
	return `${MINI_APP_ENVIRONMENT}/${route}/${hashCode}`;
};

export default constructMiniAppLink;
